import { render, staticRenderFns } from "./newplanshow.vue?vue&type=template&id=b1bf6016&scoped=true&"
import script from "./newplanshow.vue?vue&type=script&lang=js&"
export * from "./newplanshow.vue?vue&type=script&lang=js&"
import style0 from "./newplanshow.vue?vue&type=style&index=0&id=b1bf6016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bf6016",
  null
  
)

export default component.exports